import { Component, Input, Output, EventEmitter, inject } from '@angular/core';

import { LayoutService } from '@components/layout/layout.service';

import { Assessment } from '@components/assessment/assessment';

@Component({
  selector: 'app-cross-assessment-item',
  templateUrl: '../cross-assessment-item/cross-assessment-item.component.html',
  styleUrls: ['../cross-assessment-item/cross-assessment-item.component.scss'],
  standalone: false,
})
export class CrossAssessmentItemComponent {
  layoutService = inject(LayoutService);

  @Input() crossAssessment: Assessment;
  @Input() canRequestReview: boolean;
  @Output() requestReviewAssessment = new EventEmitter<Assessment>();

  editReviewAssessment() {
    this.requestReviewAssessment.emit();
  }
}
